/**
 * Stat Card
 * Reusable compact stat indicator card
 */

import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface StatCardProps {
  title: string;
  value: string;
  subValue?: string;
  color?: 'default' | 'bullish' | 'bearish' | 'warning';
}

const colorMap = {
  default: 'text-foreground',
  bullish: 'text-green-500',
  bearish: 'text-red-500',
  warning: 'text-yellow-500',
} as const;

export function StatCard({ title, value, subValue, color = 'default' }: StatCardProps) {
  return (
    <Card className="p-3">
      <CardContent className="p-0">
        <p className="text-xs text-muted-foreground">{title}</p>
        <p className={cn('text-lg font-bold', colorMap[color])}>{value}</p>
        {subValue && (
          <p className="text-xs text-muted-foreground">{subValue}</p>
        )}
      </CardContent>
    </Card>
  );
}
